import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import { Close, Loader } from "../icons";
import Input from "../common/Input";

export default function CategoryModal({
  open,
  onClose,
  onSubmit,
  mode = "add",
  initialValue = "",
  isLoading = false,
}) {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (!open) return;
    setValue(mode === "edit" ? initialValue || "" : "");
  }, [open, mode, initialValue]);
  async function handleSubmit() {
    if (!value.trim() || isLoading) return;

    try {
      await onSubmit?.(value);
      setValue("");
    } catch (error) {
      console.error(error);
    }
  }
  const title = mode === "edit" ? "Modify Category" : "New Classification";
  const buttonText = mode === "edit" ? "Save Changes" : "Initialize Category";

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[503px] pt-6 pb-11 px-0"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center justify-between mb-4  px-9">
          <div>
            <p className="text-xl leading-6 text-black font-bold">{title}</p>
            <p className="text-sm leading-4 text-black">Management Console</p>
          </div>
          <button onClick={onClose} aria-label="close">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E5E5] pt-10 px-9">
          <Input
            label="Category Designation"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            placeholder="e.g electronics, furniture, stationary"
          />

          <div className="mt-6">
            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full bg-[#6D4E8A] text-white py-3 font-bold text-sm rounded-[5px] disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2"
            >
              {isLoading && (<Loader/>)}
              {isLoading ? "Creating..." : buttonText}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
